import { mapGetters } from "vuex";

export default {
  data() {
    return {
      valid: true
    };
  },
  computed: {
    ...mapGetters(["getCurrentPage"])
  },
  methods: {
    defineRouter(tag) {
      let router = null;
      if (tag === "G1") {
        router = "/accesslist";
      } else if (tag === "K5") {
        router = "/searchlist";
      } else if (tag === "E8") {
        if (
          this.getCurrentPage === "/facilitydashreport" ||
          this.getCurrentPage === "/facilitydashengineering"
        ) {
          router = "/reportlist";
        } else {
          router = "/reportdetail";
        }
      } else if (tag === "K6") {
        router = "/registerlist";
      } else if (tag === "B6.W1") {
        router = "/planlist";
      } else if (tag === "C1") {
        router = "/companydetail";
      } else if (tag === "C1.Dash") {
        router = "/companymanagement";
      } else if (tag === "F1") {
        router = "/facilitydetail";
      } else if (tag === "F1.Dash") {
        router = "/facilitymanagement";
      } else if (tag === "U1.Dash") {
        router = "/usermanagement";
      } else if (tag === "A1") {
        router = "/assetdetail";
      } else if (tag === "A1.A1") {
        router = "/treeview";
      } else if (tag === "A1.Dash") {
        router = "/assetmanagement";
      } else if (tag === "D1") {
        router = "/documentrevisions";
      } else if (tag === "D2") {
        router = "/trackedchanges";
      } else if (tag === "D3") {
        router = "/activitylog";
      } else if (tag === "B3") {
        router = "/actiondetail";
      } else if (tag === "O1") {
        router = "/opsdetail";
      } else if (tag === "W6") {
        router = "/proceduredetail";
      } else if (tag === "E6") {
        router = "/programdetail";
      } else if (tag === "E8") {
        router = "/reportdetail";
      } else if (tag === "B1") {
        router = "/riskdetail";
      } else if (tag === "B4") {
        router = "/budgetdetail";
      } else if (tag === "B6") {
        router = "/plandetail";
      } else if (tag === "Q1") {
        router = "/orderdetail";
      } else if (tag === "M2") {
        router = "/maintstrategydetail";
      } else if (tag === "M5") {
        router = "/maintplandetail";
      } else if (tag === "M7") {
        router = "/maintcalldetail";
      } else if (tag === "E2") {
        router = "/engineeringdetail";
      } else if (tag === "E1") {
        router = "/equipmentdetail";
      } else if (tag === "L1") {
        router = "/materialdetail";
      } else if (tag === "L2") {
        router = "/bomdetail";
      } else if (tag === "S1") {
        router = "/hazarddetail";
      } else if (tag === "S6") {
        router = "/incidentdetail";
      } else if (tag === "U1") {
        router = "/userdetail";
      } else if (tag === "W1") {
        router = "/workrequestdetail";
      } else if (tag === "W2") {
        router = "/workcalldetail";
      } else if (tag === "W.TOOL") {
        router = "/worktooldetail";
      } else {
        router = null;
      }
      return router;
    },
    definePageTitle(tag, tagd, tags) {
      // console.log(" ");
      // console.log(">>> DEFINE PAGE TITLE <<<");
      // console.log(tag);
      // console.log(tagd);
      let title = null;
      if (tag === "G1") {
        if (tagd === "Z5" && tags === "C1") {
          title = "Admin Access";
        } else if (tagd === "U1" && tags === "C1") {
          title = "Company Access";
        } else if (tagd === "C1" && tags === "C1") {
          title = "Company Users";
        } else if (tagd === "U1" && tags === "F1") {
          title = "Facility Access";
        } else {
          title = null;
        }
      } else if (tag === "K6") {
        if (tagd === "F1" && tags === "C1") {
          title = "Register";
        } else if (tagd === "B4.Q1") {
          title = "Budget Orders";
        } else if (tagd === "B4.Q1") {
          title = "Budget Orders";
        } else if (tagd === "B6.W") {
          title = "Plan Work";
        } else if (tagd === "Q1") {
          title = "Company Orders";
        } else {
          title = null;
        }
      } else if (tag === "B6.W1") {
        title = "Plan Work List";
      } else {
        title = null;
      }
      return title;
    }
  }
};
